import { useTranslation } from 'react-i18next';

const comparisonData = [
  { feature: 'table_research', cssbuy: 'Excellent', superbuy: 'Good', sugargoo: 'Good', basetao: 'Average' },
  { feature: 'table_qc', cssbuy: 'Free HD Photos', superbuy: 'Paid HD', sugargoo: 'Free Basic', basetao: 'Basic' },
  { feature: 'table_shipping', cssbuy: '15+ Lines', superbuy: '12 Lines', sugargoo: '10 Lines', basetao: '8 Lines' },
  { feature: 'table_ease', cssbuy: 'Very Easy', superbuy: 'Easy', sugargoo: 'Moderate', basetao: 'Moderate' },
  { feature: 'table_fees', cssbuy: '3% Service', superbuy: '5% Service', sugargoo: '4% Service', basetao: '3% Service' },
  { feature: 'table_bestfor', cssbuy: 'Value + QC', superbuy: 'Beginners', sugargoo: 'Experienced', basetao: 'Budget' },
];

export default function ComparisonTable() {
  const { t } = useTranslation();

  return (
    <section id="comparison" className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <span className="text-sm font-medium text-primary-600 uppercase tracking-widest mb-2 block">
            Comparison
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-3">
            {t('comparison_title')}
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">
            Compare CSSBuy with other popular shopping agents to find the best option for your needs.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-background-300">
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-900 uppercase tracking-wider">
                  {t('table_feature')}
                </th>
                <th className="text-center py-3 px-4 text-sm font-semibold text-primary-700 uppercase tracking-wider bg-primary-50/40">
                  {t('table_cssbuy')}
                </th>
                <th className="text-center py-3 px-4 text-sm font-semibold text-foreground-700 uppercase tracking-wider">
                  {t('table_superbuy')}
                </th>
                <th className="text-center py-3 px-4 text-sm font-semibold text-foreground-700 uppercase tracking-wider">
                  {t('table_sugargoo')}
                </th>
                <th className="text-center py-3 px-4 text-sm font-semibold text-foreground-700 uppercase tracking-wider">
                  {t('table_basetao')}
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr
                  key={row.feature}
                  className={`border-b border-background-200/60 ${idx % 2 === 0 ? 'bg-background-50/50' : ''}`}
                >
                  <td className="py-3.5 px-4 text-sm font-medium text-foreground-900">
                    {t(row.feature)}
                  </td>
                  <td className="py-3.5 px-4 text-sm text-center text-primary-700 font-medium bg-primary-50/30">
                    {row.cssbuy}
                  </td>
                  <td className="py-3.5 px-4 text-sm text-center text-foreground-600">
                    {row.superbuy}
                  </td>
                  <td className="py-3.5 px-4 text-sm text-center text-foreground-600">
                    {row.sugargoo}
                  </td>
                  <td className="py-3.5 px-4 text-sm text-center text-foreground-600">
                    {row.basetao}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-6 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
          >
            {t('cta_main_button2')}
            <i className="ri-external-link-line w-4 h-4 flex items-center justify-center" />
          </a>
        </div>
      </div>
    </section>
  );
}